module.exports = __webpack_public_path__ + "media/safari/add-7fb4a2b2.png";